// eslint-disable-next-line no-restricted-imports
import type { NotificationGroupResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { normalizeNotificationGroups } from 'app/gamma/src/api/normalizers/notification';
import { notificationsPaneState } from './notificationsPaneState';
// eslint-disable-next-line no-restricted-imports
import { sanitizeNotificationGroups } from 'app/gamma/src/modules/state/models/notifications';
import { notificationsState } from './notificationsState';

export const loadNotificationGroupsSuccess = ({
  notificationGroupsResponse,
  isFilteringByUnread,
}: {
  notificationGroupsResponse: NotificationGroupResponse[];
  isFilteringByUnread: boolean;
}) => {
  const notificationGroups = normalizeNotificationGroups(
    notificationGroupsResponse,
  );
  if (notificationsPaneState.value.cancelLoading) {
    notificationsPaneState.setValue({
      ...notificationsPaneState.value,
      cancelLoading: false,
    });
    // this request has been replaced by another one, and is irrelevant
  } else {
    const existingGroups = notificationsPaneState.value.notificationGroupsStale
      ? []
      : notificationsState.value.notificationGroups;
    notificationsPaneState.setValue({
      ...notificationsPaneState.value,
      notificationGroupsStale: false,
    });
    notificationsState.setValue({
      ...notificationsState.value,
      notificationGroups: sanitizeNotificationGroups(
        existingGroups,
        notificationGroups,
        isFilteringByUnread,
      ),
    });
  }
};
